
import { Vue, Component } from "vue-property-decorator";
import DataItem from "./item";

@Component({
  mixins: [DataItem],
})
export default class ObjectDataItem extends Vue {
}
